import {OfficeDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
import { UserState } from '../../reducers/UserReducer';

const FUNCTION_CODE = 'GET_ALL_MISSIONS';

export async function getAllOffices(userData: UserState['userProfileData'], params: string) {
    try {
        return await OfficeDao.getAllOffices(userData?.userToken as string, params);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération des bureaux',
            error: error
        });
    }
}
